import {Realm} from "../environment/realm/realm";

export function $Uint16ArrayPrototype$(realm: Realm) {
	return realm["[[GlobalObject]]"].Uint16Array.prototype;
}
